import { c as _c } from "react/compiler-runtime";
import { utmUtils } from "@/utils/utm";
import { useEffect } from "react";

/**
 * Hook to capture and manage UTM parameters
 */
export const useUTM = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      getCurrent: utmUtils.getCurrent,
      hasValidParams: utmUtils.hasValidParams,
      clear: utmUtils.clear
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp() {
  if (typeof window === "undefined") {
    return;
  }
  const urlParams = utmUtils.extractFromURL();
  if (Object.keys(urlParams).length > 0) {
    utmUtils.save(urlParams);
  }
  utmUtils.load();
}